<script>
import ModelList from "./model-list.vue";

export default {
  name: "model-modal",
  components: {ModelList},
  props: {
    models: Array
  },
  computed: {
    remapped() {
      return this.models.map(m => {
         return m.relation || m
      })
    }
  },
  methods: {
    clicked(m) {
      this.$refs.modal.close()
      this.modalRoute(m)
    }
  }
}
</script>

<template>
  <modal title="Lookup Results" height="390px" ref="modal">
    <model-list :models="remapped" @click="clicked"/>
  </modal>
</template>

<style scoped>

</style>